import { CashOutCountriesList as country } from '../../../Cashouts/CashOutHelpers';
import { formViewPE } from './FormConfig/formViewPE';
import { formViewCO } from './FormConfig/formViewCO';

export const getFormViewByCountry = (countryCode) => {
  // eslint-disable-next-line
  switch (countryCode) {
    case country.PERU.toLowerCase():
      return formViewPE;
    case country.COLOMBIA.toLowerCase():
      return formViewCO;
  }
};
